<template>
  <div class="support-tab">
    <h3>Deal support community</h3>
    <h5>
      The Prosper Africa VDR ecosystem offers investors, advisors and capital
      seekers an opportunity to review live transactions. Connect to investors
      and specialized advisors and access U.S. government tools and capabilities
      to support U.S. investment in Africa.
    </h5>
  </div>
</template>

<script>
export default {
  name: "support-tab",
};
</script>

<style lang="scss" scoped>
.support-tab {
  color: #fff;
  text-align: center;
  padding-bottom: 150px;
  h3 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 27px;
  }
  h5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 30px;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
